import React, { useState, useCallback, useEffect } from "react"; // Add useEffect
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Captcha from "../components/Captcha";
import { jwtDecode } from "jwt-decode";
import API_BASE_URL from "../config";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { GoogleLogin } from "@react-oauth/google"; // ← NEW

function LoginPage({ setUser }) {
  const navigate = useNavigate();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const [captchaValue, setCaptchaValue] = useState(""); // Captcha value generated
  const [captchaInput, setCaptchaInput] = useState(""); // User input for captcha
  const [captchaError, setCaptchaError] = useState(""); // Error message for captcha
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    captcha: "", // Captcha value from form
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const refreshCaptcha = () => {
    setCaptchaValue(""); // Clear previous captcha value
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!executeRecaptcha) {
      setError("reCAPTCHA not loaded yet.");
      return;
    }

    // if (captchaInput !== captchaValue) {
    //   setCaptchaError("Captcha does not match.");
    //   return;
    // }

    try {
      // Prepare form data with captcha
      const recaptchaToken = await executeRecaptcha("login");
      //const formWithCaptcha = { ...formData, captcha: captchaInput };
      // const res = await axios.post(
      //   `${API_BASE_URL}/api/login`,
      //   formWithCaptcha,
      //   { withCredentials: true }
      // );
      const res = await axios.post(
        `${API_BASE_URL}/api/login`,
        { ...formData, recaptchaToken },
        { withCredentials: true },
      );
      // ... (imports and other code remain the same)

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("refresh_token", res.data.refresh_token);
        const decoded = jwtDecode(res.data.token);
        localStorage.setItem("user", JSON.stringify(decoded));
        setUser(decoded); // 🔥 Update App.js state
        // === STORE BRANCH IDS ===
        if (decoded.type === "manager" && decoded.branch_ids) {
          localStorage.setItem(
            "manager_branch_ids",
            JSON.stringify(decoded.branch_ids),
          );
        }
        // Migrate old global keys into per-user keys or just remove legacy keys:
        localStorage.removeItem("selectedCompany");
        localStorage.removeItem("selectedBranch");
        localStorage.removeItem("activeRole"); // if used
        console.log(decoded.type);
        if (decoded.type === "customer") {
          navigate("/manage-bookings");
        } else if (decoded.type === "both") {
          navigate("/role-select");
        } else if (decoded.type === "new_user") {
          navigate("/select-role"); // Redirect to role selection page
        } else if (decoded.type === "manager") {
          // Store allowed branches for filtering
          if (decoded.branch_ids) {
            localStorage.setItem(
              "manager_branch_ids",
              JSON.stringify(decoded.branch_ids),
            );
          }

          // Optional: Auto-select first branch
          if (decoded.branch_ids && decoded.branch_ids.length > 0) {
            localStorage.setItem(
              "selectedBranch",
              JSON.stringify({ id: decoded.branch_ids[0] }),
            );
          } else {
            localStorage.removeItem("selectedBranch");
          }

          navigate("/manage-company-bookings");
        } else {
          // For type "user": Auto-select if single company/branch
          try {
            const companiesRes = await axios.get(`${API_BASE_URL}/companies`);
            const companies = companiesRes.data || [];

            if (companies.length === 0) {
              alert("No companies found");
              navigate("/companies"); // Redirect to create company
              return;
            }

            if (companies.length > 1) {
              navigate("/select-company");
              return;
            }

            // Single company: Auto-select it
            const company = companies[0];
            localStorage.setItem("selectedCompany", JSON.stringify(company));

            const branchesRes = await axios.get(
              `${API_BASE_URL}/companies/${company.id}/branches`,
            );
            const branches = branchesRes.data || [];

            if (branches.length === 0) {
              alert("No branches found for the company");
              return;
            }

            if (branches.length > 1) {
              navigate("/select-branch");
              return;
            }

            // Single branch: Auto-select and go directly to manage-company-bookings
            const branch = branches[0];
            localStorage.setItem("selectedBranch", JSON.stringify(branch));
            navigate("/manage-company-bookings");
          } catch (error) {
            console.error("Error auto-selecting company/branch:", error);
            alert("Failed to load companies or branches");
            navigate("/select-company"); // Fallback
          }
        }
      } else {
        setError(res.data.message || "Login failed.");
      }
    } catch (err) {
      setError("Invalid login credentials or captcha.");
    }
  };
  // GOOGLE LOGIN SUCCESS — FULL WORKFLOW (MIRRORS handleSubmit)
  const handleGoogleSuccess = async (response) => {
    const idToken = response.credential;

    try {
      const res = await axios.post(
        `${API_BASE_URL}/google-login`,
        { id_token: idToken },
        { withCredentials: true },
      );

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("refresh_token", res.data.refresh_token);
        const decoded = jwtDecode(res.data.token);
        localStorage.setItem("user", JSON.stringify(decoded));
        setUser(decoded);
        // === STORE BRANCH IDS ===
        if (decoded.type === "manager" && decoded.branch_ids) {
          localStorage.setItem(
            "manager_branch_ids",
            JSON.stringify(decoded.branch_ids),
          );
        }
        // CLEAN OLD DATA
        localStorage.removeItem("selectedCompany");
        localStorage.removeItem("selectedBranch");
        localStorage.removeItem("activeRole");

        console.log("Google Login Type:", decoded.type);

        // === IDENTICAL NAVIGATION LOGIC ===
        if (decoded.type === "customer") {
          navigate("/manage-bookings");
        } else if (decoded.type === "both") {
          navigate("/role-select");
        } else if (decoded.type === "new_user") {
          navigate("/select-role");
        } else if (decoded.type === "manager") {
          // Store allowed branches for filtering
          if (decoded.branch_ids) {
            localStorage.setItem(
              "manager_branch_ids",
              JSON.stringify(decoded.branch_ids),
            );
          }

          // Optional: Auto-select first branch
          if (decoded.branch_ids && decoded.branch_ids.length > 0) {
            localStorage.setItem(
              "selectedBranch",
              JSON.stringify({ id: decoded.branch_ids[0] }),
            );
          } else {
            localStorage.removeItem("selectedBranch");
          }

          navigate("/manage-company-bookings");
        } else {
          // === AUTO-SELECT COMPANY & BRANCH (Same as handleSubmit) ===
          try {
            const companiesRes = await axios.get(`${API_BASE_URL}/companies`);
            const companies = companiesRes.data || [];

            if (companies.length === 0) {
              alert("No companies found");
              navigate("/companies");
              return;
            }

            if (companies.length > 1) {
              navigate("/select-company");
              return;
            }

            const company = companies[0];
            localStorage.setItem("selectedCompany", JSON.stringify(company));

            const branchesRes = await axios.get(
              `${API_BASE_URL}/companies/${company.id}/branches`,
            );
            const branches = branchesRes.data || [];

            if (branches.length === 0) {
              alert("No branches found for the company");
              return;
            }

            if (branches.length > 1) {
              navigate("/select-branch");
              return;
            }

            const branch = branches[0];
            localStorage.setItem("selectedBranch", JSON.stringify(branch));
            navigate("/manage-company-bookings");
          } catch (error) {
            console.error("Error auto-selecting company/branch:", error);
            alert("Failed to load companies or branches");
            navigate("/select-company");
          }
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || "Google login failed");
    }
  };

  const handleGoogleFailure = (error) => {
    console.error("Google Login Failed:", error);
    setError("Google login failed. Please try again.");
  };
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5 col-12">
          <div className="inbx formbxx p-4 shadow-sm rounded border">
            <div className="frmtbx text-center mb-4">
              <h2 className="fw-bold mb-2">
                <i className="bi bi-box-arrow-in-right me-2"></i>Sign in
              </h2>
              <p className="mb-4 text-center  pb-3">
                to continue to TickTickGo.in
              </p>
            </div>

            {error && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {error}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setError(null)} // ← add this if you want dismissible
                ></button>
              </div>
            )}

            <form onSubmit={handleSubmit} className="formarea">
              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-medium">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  className="form-control"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  autoFocus
                />
              </div>

              <div className="mb-4">
                <label htmlFor="password" className="form-label fw-medium">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  className="form-control"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              {/* ✅ Email Login FIRST */}
              <button
                type="submit"
                className="btn btn-success w-100 py-2 fw-medium mb-4"
              >
                Login with Email
              </button>

              {/* ✅ Google Login Section */}
              <div className="mb-4">
                <div className="text-center mb-2 fw-semibold text-muted small">
                  — For Customers —
                </div>

                <div className="d-grid google-btn-wrapper">
                  <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={handleGoogleFailure}
                    useOneTap
                    theme="outline"
                    size="large"
                    text="continue_with"
                    shape="rectangular"
                    logo_alignment="left"
                    width={320}
                  />
                </div>

                <div className="text-center mt-2">
                  <small className="text-muted">
                    Businesses,{" "}
                    <a
                      href="/signup"
                      className="fw-medium text-decoration-none text-primary"
                    >
                      register here first
                    </a>{" "}
                    to access business features.
                  </small>
                </div>
              </div>

              <div className="mt-4 text-center small">
                <a
                  href="/forgot-password"
                  className="text-success text-decoration-none fw-medium"
                >
                  Forgot Password?
                </a>
              </div>

              <div className="mt-2 text-center small">
                <span className="text-muted">Don't have an account? </span>
                <a
                  href="/signup"
                  className="text-success text-decoration-none fw-medium"
                >
                  Sign up
                </a>
              </div>
            </form>
          </div>
        </div>

        <div className="col-md-7 col-12 d-none d-md-block gx-0">
          <img
            src="/log-bg.png"
            alt="Login background"
            className="login-bg img-fluid h-100 object-fit-cover rounded-end"
          />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
